import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { notBlank } from "../../util/ext";
import { curry } from "ramda";

const collectionConstraints = {
  name: {
    presence: {
      allowEmpty: false,
      message: "^Title must not be blank",
    },
  },
  description: {
    presence: {
      allowEmpty: false,
      message: "^Description must not be blank",
    },
  },
};

export const validateCollectionField = (field, value, errors = {}) =>
  validateField(collectionConstraints, field, value, errors);

export const validateCollection = R.partial(validateObject, [
  collectionConstraints,
]);

export const hasError = curry((errors, field) => notBlank(errors[field]));

export const firstError = curry((errors, field) =>
  errors[field] ? errors[field][0] : "",
);
